
// request请求路径管理规则
// 大写字母 下划线连接
const REQUEST_PATH={
  curinfo:"key/curinfo",//签名api
  JING_WEI_LOCATION:"/baseData/city/location", //经纬度
  GET_LOCATION_BY_IP:"/qiandao/index/getLocationByIp",  //ip地址
  //经销商相关接口
  //经销商列表
  GET_DEALER_LIST:'api/dealer/getdealerList',
  //优惠促销详情   
  DEALER_LABEL_ACTIVITY:"api/dealer/getCsDealerLabelActivity",
  // 值得买 MOD1值得买  MOD2销量高 MOD3人气热  MOD4很安全
  INDEX_MOD1:'aconfig/m/ranking/show/reducedprice/listbycondition',//降价促销
  INDEX_MOD2:'aconfig/m/ranking/show/sales/listbycondition',
   // 品牌列表
  GET_BRANCH_LIST:'autostorage/api/masterbrand/list',
  // 车型列表
  GET_CAR_LIST:'/baseData/car/tcStyleContainFirmBrand?brandId=',
  REDUCED_PRICE:'/aconfig/m/ranking/show/reducedprice/listbycondition',//获取降价排行车型信息
  LIST_BY_SALES:'/aconfig/m/ranking/show/sales/listbycondition',//获取销量排行车型信息
  LIST_BY_CONDITION:'/aconfig/m/ranking/show/popular/listbycondition',//获取首页推荐车信息
  LIST_BY_SAFETY:'/aconfig/m/ranking/show/safety/listbycondition',//获取安全排行车型信息
  WEI_NI_TUI_JIAN:'/aconfig/m/ranking/show/pricelevelgroup/list',//获取人气排行车型信息
  //上市新车
  TIME_TO_MARKET:"aconfig/m/ranking/show/timeToMarket",
  // 品牌列表
  GET_BRANCH_LIST:'autostorage/api/masterbrand/list',
  recommendcarstyle:"/webapi/finance/recommendcarstyle/list",
  /*获取品牌*/
  // tcBrand:"/baseData/car/tcBrand",
  /*获取车型*/
  // tcStyle:"/baseData/car/tcStyle",
  carStyleLibrary: "/autostorage/api/car/dynamicQuery",
  /**提交报名信息***/
  applyForTcjAsyn:"/adConfig/tcj/applyForTcjAsyn",
  //我的门票
  MYTICKET:"/aconfig/m/ticke/user/list",
  //活动详情
  ACTIVEINFO:"/aconfig/m/periods/show/get",
  /*获取品牌*/
  TC_BRAND:"/baseData/car/tcBrand",
  /*获取车型*/
  BASETCSTYLE:"/baseData/car/tcStyle",
  /**提交报名信息***/
  APPLYFORTCJASYN:"/aconfig/tcj/applyForTcjAsyn",
  //活动推荐
  ACTIVERECOMMEND:"/aconfig/m/periods/show/periphery/list",
  //票券详情
  INFOTICKET:"/aconfig/m/ticke/showTicketDetail",
  //token获取手机
  GET_PHONE:"/login/login/v2/ajaxAuth/auth",
  GET_ADVERT_LIST:'/webapi/finance/advert/getadvertlist',//广告列表
}

export {REQUEST_PATH};



// WEBPACK FOOTER //
// ./static/js/lib/requestPath.js